export enum TransactionFilterMenu {
    PARENT = 'parent',
    DATE = 'dateMenu',
    TYPE = 'typeMenu',
    CATEGORY = 'categoryMenu',
    ACCOUNT = 'accountMenu'
}
